import { createIndexedLocalStore } from '../../../utilities/localStorage-store';

const SERVER_SYNC_PREFIX = 'grapesjs-server-sync:';
const SERVER_SYNC_TTL_MS = 5 * 60 * 1000;

const editorlocalstore = createIndexedLocalStore({
    keyPrefix: 'grapesjs-autosave:',
    indexKey: 'grapesjs-autosave:index',
    defaultMaxAgeMs: 4 * 60 * 60 * 1000,
    defaultMaxEntries: 3,
    composeKey: (modelId, referenceId) => `${modelId}:${referenceId}`,
    createEntry: ({ keyParts, data, savedAt }) => {
        const [modelId, referenceId] = keyParts;
        return { data, savedAt, modelId, referenceId };
    },
});

const getStorage = () => window?.localStorage || null;

const getServerSyncKey = (modelId, referenceId) =>
    `${SERVER_SYNC_PREFIX}${modelId}:${referenceId}`;

const markServerSynced = (modelId, referenceId) => {
    const storage = getStorage();
    if (!storage) {
        return;
    }
    try {
        storage.setItem(
            getServerSyncKey(modelId, referenceId),
            Date.now().toString()
        );
    } catch (e) {
        console.warn('Failed to mark GrapesJS content as server-synced', e);
    }
};

const clearServerSynced = (modelId, referenceId) => {
    const storage = getStorage();
    if (!storage) {
        return;
    }
    try {
        storage.removeItem(getServerSyncKey(modelId, referenceId));
    } catch (e) {
        console.warn('Failed to clear GrapesJS server-sync flag', e);
    }
};

const wasRecentlyServerSynced = (
    modelId,
    referenceId,
    withinMs = SERVER_SYNC_TTL_MS
) => {
    const storage = getStorage();
    if (!storage) {
        return false;
    }
    try {
        const raw = storage.getItem(getServerSyncKey(modelId, referenceId));
        if (!raw) {
            return false;
        }
        const syncedAt = Number.parseInt(raw, 10);
        if (!Number.isFinite(syncedAt)) {
            clearServerSynced(modelId, referenceId);
            return false;
        }
        if (Date.now() - syncedAt > withinMs) {
            clearServerSynced(modelId, referenceId);
            return false;
        }
        return true;
    } catch (e) {
        console.warn('Failed to read GrapesJS server-sync flag', e);
        return false;
    }
};

export default {
    ...editorlocalstore,
    markServerSynced,
    clearServerSynced,
    wasRecentlyServerSynced,
};
